// jQuery(document).ready(function($){
//
// // Code goes here
//   $('.show_en').click(function(){
//     $('.product_cat').hide();
//     $('.product_en').show();
//     console.log('show_en');
//   });
//   $('.show_cat').click(function(){
//     $('.product_en').hide();
//     $('.product_cat').show();
//     console.log('show_cat');
//   });
//
// });

jQuery(document).ready(function ($) {
  //hack pq funcioni el woocommerce_addons amb mes d'un producte en una pagina
  if ($("body").hasClass("page-template-page-visites")) {
    woocommerce_addons_params.is_bookings = 0;
    // console.log('woocommerce_addons_params.is_bookings',woocommerce_addons_params.is_bookings)
  }
  //end hack

  if ($("body").hasClass("page-template-page-visites")) {
    $(".wc-pao-addons-container")
      .find("input:radio:first")
      .prop("checked", true);
    if (
      $(".wc-pao-addons-container").find("input:radio:first").prop("checked")
    ) {
      $(".wc-pao-addons-container")
        .find("textarea")
        .parents(".wc-pao-addon")
        .hide();
    } else {
      $(".wc-pao-addons-container")
        .find("textarea")
        .parents(".wc-pao-addon")
        .show();
    }

    $(".wc-pao-addons-container").on("change", function () {
      // console.log('radiofirst',$(this).find('input:radio:first').prop('checked'))
      if ($(this).find("input:radio:first").prop("checked")) {
        $(this).find("textarea").parents(".wc-pao-addon").hide();
      } else {
        $(this).find("textarea").parents(".wc-pao-addon").show();
      }
    });
  }

  //fix navbar on scroll
  var stickyOffset = $(".top-navbar").offset().top;
  $(window).scroll(function () {
    var sticky = $(".top-navbar"),
      scroll = $(window).scrollTop();
    if (scroll >= stickyOffset) sticky.addClass("fixed-top");
    else sticky.removeClass("fixed-top");
  });

  if ($(".visita_col").length) {
    $(".visita_col").on("click", function () {
      // console.log($(this).find('.wp-block-button__link'));
      // $(this).find('a.wp-block-button__link').trigger('click');
      location.href = $(this).find("a.wp-block-button__link").attr("href");
    });
  }

  $(".down-arrow").click(function () {
    if ($(".top-navbar").hasClass("fixed-top")) {
      if ($("ul.main-menu ul.dropdown-menu").length) {
        $("html,body").animate(
          {
            scrollTop:
              $(this).parents(".wp-block-cover").next("div").offset().top - 100,
          },
          "slow"
        );
      } else {
        $("html,body").animate(
          {
            scrollTop:
              $(this).parents(".wp-block-cover").next("div").offset().top - 70,
          },
          "slow"
        );
      }
    } else {
      $("html,body").animate(
        {
          scrollTop:
            $(this).parents(".wp-block-cover").next("div").offset().top -
            120 -
            stickyOffset,
        },
        "slow"
      );
    }
  });

  //visites show language selector

  if ($("article.visites").length) {
    if ($(".woocommerce-notices-wrapper").is(":not(:empty)")) {
      //do something
      // console.log('not empty notices')
      // console.log($('.woocommerce-notices-wrapper:not(:empty)').parents('.product_cat').length)
      if (
        $(".woocommerce-notices-wrapper:not(:empty)").parents(".product_cat")
          .length
      ) {
        $(".product_reserva").show();
        $(".product_gift").hide();
        setTimeout(function () {
          $("#show_cat").trigger("click");
        }, 100);
      } else if (
        $(".woocommerce-notices-wrapper:not(:empty)").parents(".product_en")
          .length
      ) {
        $(".product_reserva").show();
        $(".product_gift").hide();
        setTimeout(function () {
          $("#show_en").trigger("click");
        }, 100);
      } else if (
        $(".woocommerce-notices-wrapper:not(:empty)").parent(".product_gift")
          .length
      ) {
        $(".product_gift").show();
        $(".product_reserva").hide();
        $(".product_en").hide();
        $(".product_cat").hide();
        setTimeout(function () {
          $("#show_gift").trigger("click");
        }, 100);
      }

      setTimeout(function () {
        if ($(".top-navbar").hasClass("fixed-top")) {
          $("html,body").animate(
            { scrollTop: $(".woocommerce-notices-wrapper").offset().top - 370 },
            "slow"
          );
        } else {
          $("html,body").animate(
            {
              scrollTop:
                $(".woocommerce-notices-wrapper").offset().top -
                370 -
                stickyOffset,
            },
            "slow"
          );
        }
      }, 200);
    }

    $("#show_visita").click(function () {
      // console.log('show_visita',stickyOffset)
      // $('#show_cat .wp-block-button__link').removeClass('active')
      // $(this).find('.wp-block-button__link').addClass('active')
      $(".product_reserva").show();
      $(".product_gift").hide();

      if ($(".top-navbar").hasClass("fixed-top")) {
        $("html,body").animate(
          { scrollTop: $(".product_reserva").offset().top - 100 },
          "slow"
        );
      } else {
        $("html,body").animate(
          {
            scrollTop: $(".product_reserva").offset().top - 100 - stickyOffset,
          },
          "slow"
        );
      }
      $(".wc-bookings-booking-form-hide")
        .addClass("wc-bookings-booking-form")
        .removeClass("wc-bookings-booking-form-hide"); //hack pq funcioni el woocommerce_addons amb mes d'un producte en una pagina
    });
    $("#show_gift").click(function () {
      // console.log('show_gift')
      $("#show_cat .wp-block-button__link").removeClass("active");
      // $(this).find('.wp-block-button__link').addClass('active')
      $(".product_gift").show();
      $(".product_reserva").hide();
      $(".product_en").hide();
      $(".product_cat").hide();
      if ($(".top-navbar").hasClass("fixed-top")) {
        $("html,body").animate(
          { scrollTop: $(".product_gift").offset().top - 100 },
          "slow"
        );
      } else {
        $("html,body").animate(
          { scrollTop: $(".product_gift").offset().top - 100 - stickyOffset },
          "slow"
        );
      }
      woocommerce_addons_params.is_bookings = 0; //hack pq funcioni el woocommerce_addons amb mes d'un producte en una pagina
      $(".wc-bookings-booking-form")
        .addClass("wc-bookings-booking-form-hide")
        .removeClass("wc-bookings-booking-form"); //hack pq funcioni el woocommerce_addons amb mes d'un producte en una pagina
      // $(".product_gift .cart").off(); //elimino els events del from.cart (no funciona bé)
    });

    $("#show_en").click(function () {
      // console.log('show_en')
      $("#show_cat .wp-block-button__link").removeClass("active");
      $(this).find(".wp-block-button__link").addClass("active");
      $(".product_en").show();
      $(".product_cat").hide();
      $(".product_gift").hide();
      // console.log(wc_bookings_booking_form.product_id);
      // console.log($('.product_en input.wc-booking-product-id').val())
      if (
        wc_bookings_booking_form.product_id !==
        $(".product_en input.wc-booking-product-id").val()
      ) {
        console.log("refresh calendar");
        wc_bookings_booking_form.product_id = $(
          ".product_en input.wc-booking-product-id"
        ).val();
        // wc_bookings_booking_form.wc_bookings_date_picker.init();
        executarAmbReintent();
        
      }
      // $('html,body').animate({scrollTop: $('.product_en').offset().top - 70},'slow');
    });
    $("#show_cat").click(function () {
      // console.log('show_cat')
      $("#show_en .wp-block-button__link").removeClass("active");
      $(this).find(".wp-block-button__link").addClass("active");
      $(".product_cat").show();
      $(".product_en").hide();
      $(".product_gift").hide();
      // console.log(wc_bookings_booking_form.product_id);
      // console.log($('.product_cat input.wc-booking-product-id').val())
      if (
        wc_bookings_booking_form.product_id !==
        $(".product_cat input.wc-booking-product-id").val()
      ) {
        // console.log('refresh calendar')
        wc_bookings_booking_form.product_id = $(
          ".product_cat input.wc-booking-product-id"
        ).val();
        // wc_bookings_booking_form.wc_bookings_date_picker.init();
        executarAmbReintent();
      }
      // $('html,body').animate({scrollTop: $('.product_cat').offset().top - 70},'slow');
    });

    function executarAmbReintent() {
      let success = false;
      while (!success) {
        try {
          wc_bookings_booking_form.wc_bookings_date_picker.init();
          success = true; // Si s'arriba aquí, la funció s'ha executat sense errors.
        } catch (error) {
          console.error("Error durant l'execució, reintentant...", error);
          // Opcional: Espera un moment abans de reintentar
          // sleep(1000); // Espera 1 segon (necessitaràs implementar una funció sleep)
        }
      }
    }
    
   
  }

  $(".scroll-anchor a").click(function (e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $("html,body").animate({ scrollTop: $(aid).offset().top - 100 }, "slow");
  });

  $(".slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $(".woocommerce-product-gallery__image a").click(function (e) {
    e.preventDefault;
  });

  // Auto open minicart when add
  function checkminicartupdate() {
    if ($(".add_to_cart_button.ajax_add_to_cart").hasClass("added")) {
      $(".add_to_cart_button.ajax_add_to_cart").removeClass("added");
      $("div.dropdown.minicart a.dropdown-toggle").dropdown("toggle");
      setTimeout(checkminicartupdate, 500);
    } else {
      setTimeout(checkminicartupdate, 500);
    }
  }
  checkminicartupdate();

  /**
   * Add quantity field on the shop page.
   */
  $(".woocommerce .products").on("click", ".quantity input", function () {
    return false;
  });
  $(".woocommerce .products").on("change input", ".quantity .qty", function () {
    var add_to_cart_button = $(this)
      .parents(".product")
      .find(".add_to_cart_button");
    // For AJAX add-to-cart actions
    add_to_cart_button.attr("data-quantity", $(this).val());
    // For non-AJAX add-to-cart actions
    add_to_cart_button.attr(
      "href",
      "?add-to-cart=" +
        add_to_cart_button.attr("data-product_id") +
        "&quantity=" +
        $(this).val()
    );
  });
  // Trigger on Enter press
  $(".woocommerce .products").on("keypress", ".quantity .qty", function (e) {
    if ((e.which || e.keyCode) === 13) {
      $(this).parents(".product").find(".add_to_cart_button").trigger("click");
    }
  });

  // Pares Baltà checkout

  const get_text_between = (str, dis, dat) => {
    return str.substring(str.indexOf(dis) + dis.length, str.lastIndexOf(dat));
  };

  const set_visibility = (el, state) => {
    if (state) {
      el.slideDown(400, function () {
        el.addClass("forced-display");
      });
    } else {
      el.removeClass("forced-display");
      el.slideUp();
    }
  };

  if (jQuery("body").hasClass("woocommerce-checkout")) {
    // console.log("in the checkout page")

    jQuery("#contact_profile_field .select2-selection__placeholder").text(
      jQuery("#contact_profile_field label").text()
    );

    jQuery("#invoice_needed").each(function () {
      if (jQuery(this).prop("checked")) {
        jQuery("#nif_field").show().addClass("validate-required");
        jQuery("#billing_company_field").show().addClass("validate-required");
      } else {
        jQuery("#nif_field")
          .hide()
          .removeClass("validate-required woocommerce-invalid");
        jQuery("#billing_company_field")
          .hide()
          .removeClass("validate-required woocommerce-invalid");
      }
    });
    jQuery("#nif_field .optional").hide();
    jQuery("#invoice_needed").change(function () {
      if (jQuery(this).prop("checked")) {
        jQuery("#nif_field").show().addClass("validate-required");
        jQuery("#billing_company_field").show().addClass("validate-required");
      } else {
        jQuery("#nif_field")
          .hide()
          .removeClass("validate-required woocommerce-invalid");
        jQuery("#billing_company_field")
          .hide()
          .removeClass("validate-required woocommerce-invalid");
      }
    });

    jQuery("form.woocommerce-checkout").on("submit", function () {
      if (
        jQuery("#nif_field").hasClass("validate-required") &&
        jQuery("#nif_field").val() == ""
      ) {
        jQuery("#nif_field").addClass("woocommerce-invalid");
        return false;
      }
      if (
        jQuery("#billing_company_field").hasClass("validate-required") &&
        jQuery("#billing_company_field").val() == ""
      ) {
        jQuery("#billing_company_field").addClass("woocommerce-invalid");
        return false;
      }
      jQuery('#billing_phone').val(jQuery('#billing_phone').val().replace(/\s/g, ''));
    });

    //jQuery("#order_comments_field").detach().insertAfter("#billing_state_field")
    jQuery(".form-row.form-row-wide#contact_profile_field")
      .detach()
      .insertAfter("#billing_state_field");
    jQuery("#wine_relationship_field")
      .detach()
      .insertAfter(".form-row.form-row-wide#contact_profile_field");
    jQuery("#com_ens_ha_conegut_field")
      .detach()
      .insertAfter("#wine_relationship_field");

    jQuery(".woocommerce-shipping-fields").after(
      `<div id="delivery_details_box"></div>`
    );
    jQuery("#delivery_details_box").append(
      jQuery("#order_comments_toggle_field")
    );
    jQuery("#delivery_details_box").append(jQuery("#order_comments_field"));
    set_visibility(
      jQuery("#order_comments_field"),
      jQuery("#order_comments_toggle_field input").prop("checked")
    );
    jQuery("#order_comments_toggle_field").change(function () {
      set_visibility(
        jQuery("#order_comments_field"),
        jQuery("#order_comments_toggle_field input").prop("checked")
      );
    });

    jQuery("#delivery_details_box").after(`<div id="gift_message_box"></div>`);
    jQuery("#gift_message_box").append(jQuery("#custom_message_toggle_field"));
    jQuery("#gift_message_box").append(jQuery("#custom_message_field"));
    set_visibility(
      jQuery("#custom_message_field"),
      jQuery("#custom_message_toggle_field input").prop("checked")
    );
    jQuery("#custom_message_toggle_field").change(function () {
      set_visibility(
        jQuery("#custom_message_field"),
        jQuery("#custom_message_toggle_field input").prop("checked")
      );
    });

    jQuery("#multiple-bottles_field").detach().insertBefore("#payment");

    jQuery("#gift_message_box").after(`<div id="invoice_needed_box"></div>`);
    jQuery("#invoice_needed_box").append(jQuery("#invoice_needed_field"));
    jQuery("#invoice_needed_box").append(jQuery("#nif_field"));
    jQuery("#invoice_needed_box").append(jQuery("#billing_company_field"));

    jQuery(".woocommerce-account-fields")
      .detach()
      .insertAfter("#invoice_needed_box");

    jQuery("body").on("updated_checkout", function () {
      console.log("updated_checkout");
      if (jQuery(".form-row.place-order #gdpr_field").length == 0) {
        jQuery("#gdpr_field")
          .clone()
          .insertAfter(".woocommerce-terms-and-conditions-wrapper");
      }

      if (jQuery(".form-row.place-order #edat_field").length == 0) {
        jQuery("#edat_field")
          .clone()
          .insertAfter(".woocommerce-terms-and-conditions-wrapper");
      }
    });

    // jQuery("#edat_field").detach().insertAfter(".form-row.place-order");

    // jQuery("#gdpr_field").detach().insertAfter("#edat_field");

    // jQuery("#edat_field").detach().insertAfter(".woocommerce-checkout-payment")
    // jQuery("#gdpr_field").detach().insertAfter("#edat_field")

    // jQuery("#place_order").insertAfter("#gdpr_field")

    // jQuery(".payment_method_paypal").html(jQuery(".payment_method_paypal").html().replace("PayPal", ""))
    // jQuery(".payment_method_paypal a").remove()

    jQuery(".form-row.validate-required").each(function () {
      const placeholder = jQuery(this).find("input").attr("placeholder");
      jQuery(this)
        .find("input")
        .attr("placeholder", placeholder + " *");
    });

    /* move the login nag */
    if (jQuery(".dms3-login-nag").length > 0) {
      jQuery(".dms3-login-nag")
        .detach()
        .insertAfter(".woocommerce-billing-fields h3");
      jQuery(".dms3-login-nag").css("display", "flex");
      jQuery(".woocommerce-form-login").detach().insertAfter(".dms3-login-nag");
      jQuery(".dms3-login-nag-link").click(function () {
        jQuery(".woocommerce-form-login").slideToggle();
      });
      /* remove all labels and make them placeholders in the inputs */
      jQuery(".woocommerce-form-login .form-row").each(function () {
        jQuery(this).removeClass("form-row-first");
        jQuery(this).removeClass("form-row-last");
        if (
          jQuery(this).find("label").length > 0 &&
          jQuery(this).find("input").length > 0
        ) {
          jQuery(this)
            .find("input")
            .attr("placeholder", jQuery(this).find("label").text());
          jQuery(this).find("label").remove();
        }
      });
      // Modificar placeholders problemàtics
      //              jQuery("html[lang='ca'] #contact_profile").attr("data-placeholder","Perfil");
      //            jQuery("html[lang='es-ES'] #billing_address_1").attr("placeholder","Dirección");
      //            jQuery("html[lang='en-US'] #billing_address_1").attr("placeholder","Dirección");
      //            jQuery("#contact_profile").select2();
    }

    /* and the coupon form */
    if (jQuery(".woocommerce-form-coupon-toggle").length > 0) {
      jQuery("#order_review_heading").after(`<div id="coupon_box"></div>`);
      jQuery("#coupon_box").append(jQuery("#coupon_toggle_field"));
      jQuery("#coupon_box").append(jQuery(".woocommerce-form-coupon"));
      set_visibility(
        jQuery(".woocommerce-form-coupon"),
        jQuery("#coupon_toggle_field input").prop("checked")
      );
      set_visibility(
        jQuery("#coupon_box .woocommerce-error"),
        jQuery("#coupon_toggle_field input").prop("checked")
      );
      jQuery("#coupon_toggle_field").change(function () {
        set_visibility(
          jQuery("#coupon_box .woocommerce-error"),
          jQuery("#coupon_toggle_field input").prop("checked")
        );
        set_visibility(
          jQuery(".woocommerce-form-coupon"),
          jQuery("#coupon_toggle_field input").prop("checked")
        );
      });
    }

    jQuery("body").on("update_checkout", function () {
      jQuery(".woocommerce-checkout .textwidget").remove();
    });

    jQuery("body").on("updated_checkout", function () {
      let done = false;
      jQuery(
        ".shop_table.woocommerce-checkout-review-order-table:not(.sec)"
      ).each(function () {
        if (done) {
          jQuery(this).remove();
        }
        done = true;
      });
      done = false;
      jQuery(".shop_table.woocommerce-checkout-review-order-table.sec").each(
        function () {
          if (done) {
            jQuery(this).remove();
          }
          done = true;
        }
      );
      done = false;
      jQuery(".woocommerce-checkout .textwidget").each(function () {
        if (done) {
          jQuery(this).remove();
        }
        done = true;
      });
      jQuery(".woocommerce-checkout .textwidget")
        .detach()
        .insertAfter("#coupon_box");

      // visits
      /*
        if (jQuery(".woocommerce-checkout-review-order-table .cart_item .product-name > p").length > 0) {
            const beneficiary = get_text_between(jQuery(".woocommerce-checkout-review-order-table .cart_item .product-name > p").html(), "</strong>: ", "<br>")
            jQuery(".woocommerce-checkout-review-order-table .cart_item .product-name > p").hide()
            const html = jQuery(".woocommerce-checkout-review-order-table .cart_item .product-name").html()
            jQuery(".woocommerce-checkout-review-order-table .product-name").html(html.substring(0, html.indexOf("<")) + "<br>" + beneficiary + html.substring(html.indexOf("<")))
        }
        */
    });

    // changes the placeholder of selects to be their labels
    jQuery(".woocommerce-input-wrapper select").each(function () {
      const placeholder = jQuery(
        `label[for="` + jQuery(this).attr("id") + `"]`
      ).text();
      jQuery(this).attr("data-placeholder", placeholder);
    });

    jQuery("form.woocommerce-checkout .col-2 > *").each(function () {
      jQuery(this).appendTo("form.woocommerce-checkout .col-1");
    });
    jQuery("form.woocommerce-checkout > *:not(.col2-set)").each(function () {
      jQuery(this).appendTo("form.woocommerce-checkout .col-2");
    });

    $(".woocommerce-checkout #custom_message").attr("maxlength", "50");
  }

  // END Pares Baltà checkout

  //Voucher count characters
  if ($(".voucher-fields-wrapper").length) {
    var maxlength = $(".voucher-fields-wrapper textarea.form-control").attr(
      "maxlength"
    );
    if (typeof maxlength !== "undefined" && maxlength !== false) {
      maxlength = parseInt(maxlength);
      var characterCount = $(
        ".voucher-fields-wrapper textarea.form-control"
      ).val().length;
      $(".voucher-fields-wrapper textarea.form-control").after(
        "<div class='textarea_count'>" +
          characterCount +
          " / " +
          maxlength +
          "</div>"
      );

      $(".voucher-fields-wrapper textarea.form-control").keyup(function () {
        var characterCount = $(this).val().length;
        var maxlength = $(this).attr("maxlength");
        $(".voucher-fields-wrapper div.textarea_count").text(
          characterCount + " / " + maxlength
        );
        console.log("keyup", "0 / " + maxlength, $(this));
      });
    }
  }
  //END count characters

  $(".nav-button").click(function () {
    $("body").toggleClass("nav-open");
    $(".mobile-offcanvas").toggleClass("show");
  });

  if ($("select.wcpbc-currency-switcher").length) {
    if ($("html[lang=es-ES]").length) {
      $("select.wcpbc-currency-switcher option[data-currency=EUR]").text(
        "Resto del mundo"
      );
      $("select.wcpbc-currency-switcher option[data-currency=USD]").text(
        "Estados Unidos"
      );
    }
    if ($("html[lang=ca]").length) {
      $("select.wcpbc-currency-switcher option[data-currency=EUR]").text(
        "Resta del món"
      );
      $("select.wcpbc-currency-switcher option[data-currency=USD]").text(
        "Estats Units"
      );
    }
    if ($("html[lang=en-US]").length) {
      $("select.wcpbc-currency-switcher option[data-currency=EUR]").text(
        "Rest of the world"
      );
      $("select.wcpbc-currency-switcher option[data-currency=USD]").text(
        "United States"
      );
    }

    if ($("select.wcpbc-currency-switcher").val() == "US") {
      $("#product-search-filter-attribute-2").hide();
    }
  }

  //prepopulate formulari reserva productes

  if ($("form#gform_7").length) {
    console.log();
    $("#input_7_36").val($("h1.product_title").text());
    $("#input_7_35").val($("div#sku").text());

    $("form#gform_7").submit(function (event) {
      // alert( "Handler for .submit() called." );
      $("#input_7_37").val(
        "SKU: " +
          $("#input_7_35").val() +
          "\nProducte: " +
          $("#input_7_36").val() +
          "\nAmpolles: " +
          $("#input_7_34").val() +
          "\n" +
          $("#input_7_27").val()
      );
    });
  }

  var current_currency = $(".woocommerce-Price-currencySymbol").first().text();
  jQuery(document.body).on("update_checkout", function () {
    // console.log('update_checkout triggered');
    current_currency = $(".woocommerce-Price-currencySymbol").first().text();
  });
  jQuery(document.body).on("updated_checkout", function () {
    // console.log('updated_checkout triggered');
    if (
      current_currency !== $(".woocommerce-Price-currencySymbol").first().text()
    ) {
      // console.log('canvi de moneda')
      location.reload();
    }
  });

  function resetQty() {
    $("input[type=number].qty")
      .attr("step", "1")
      .attr("min", "")
      .attr("max", "");

    $("body.single-product input[type=number].qty").attr("value", "1").change();
    $("body.post-type-archive-product input[type=number].qty")
      .attr("value", "1")
      .change();
  }

  resetQty();

  $(document).ajaxComplete(function (event, request, settings) {
    resetQty();
  });

  //Start picnic

  //ESP
  $('[for="wc_bookings_field_persons_34344"]' ).prepend( '<input type="checkbox" id="wc_bookings_checkbox_persons_34344" value="true" style=" width: auto; margin-right: 5px;"/>' );
  $('[name="wc_bookings_field_persons_34344"]').hide();

  $('#wc_bookings_checkbox_persons_34344, #wc_bookings_field_persons_5061, #wc_bookings_field_persons_5062').change(function() {
    espcheckPicnic()
  });
  function espcheckPicnic(){
    if( $('#wc_bookings_checkbox_persons_34344').prop('checked') ) {
      var persons = parseInt($('#wc_bookings_field_persons_5061').val()) + parseInt($('#wc_bookings_field_persons_5062').val());
      $('[name="wc_bookings_field_persons_34344"]').val(persons)
    }else{
      $('[name="wc_bookings_field_persons_34344"]').val(0)
    }
  }
  

  $('[for="wc_bookings_field_persons_146692"]' ).prepend( '<input type="checkbox" id="wc_bookings_checkbox_persons_146692" value="true" style=" width: auto; margin-right: 5px;"/>' );
  $('[name="wc_bookings_field_persons_146692"]').hide();
  $('#wc_bookings_checkbox_persons_146692, #wc_bookings_field_persons_5061, #wc_bookings_field_persons_5062').change(function() {
    espcheckPicnic2()
  });
  function espcheckPicnic2(){
    if( $('#wc_bookings_checkbox_persons_146692').prop('checked') ) {
      var persons = parseInt($('#wc_bookings_field_persons_5061').val()) + parseInt($('#wc_bookings_field_persons_5062').val());
      $('[name="wc_bookings_field_persons_146692"]').val(persons)
    }else{
      $('[name="wc_bookings_field_persons_146692"]').val(0)
    }
  }

  $('[for="wc_bookings_field_persons_146698"]' ).prepend( '<input type="checkbox" id="wc_bookings_checkbox_persons_146698" value="true" style=" width: auto; margin-right: 5px;"/>' );
  $('[name="wc_bookings_field_persons_146698"]').hide();
  $('#wc_bookings_checkbox_persons_146698, #wc_bookings_field_persons_5064, #wc_bookings_field_persons_5065').change(function() {
    espcheckPicnic3()
  });
  function espcheckPicnic3(){
    if( $('#wc_bookings_checkbox_persons_146698').prop('checked') ) {
      var persons = parseInt($('#wc_bookings_field_persons_5064').val()) + parseInt($('#wc_bookings_field_persons_5065').val());
      $('[name="wc_bookings_field_persons_146698"]').val(persons)
    }else{
      $('[name="wc_bookings_field_persons_146698"]').val(0)
    }
  }


 //CAT
 $('[for="wc_bookings_field_persons_146693"]' ).prepend( '<input type="checkbox" id="wc_bookings_checkbox_persons_146693" value="true" style=" width: auto; margin-right: 5px;"/>' );
 $('[name="wc_bookings_field_persons_146693"]').hide();
 $('#wc_bookings_checkbox_persons_146693, #wc_bookings_field_persons_5895, #wc_bookings_field_persons_5896').change(function() {
   catcheckPicnic()
 });
 function catcheckPicnic(){
   if( $('#wc_bookings_checkbox_persons_146693').prop('checked') ) {
     var persons = parseInt($('#wc_bookings_field_persons_5895').val()) + parseInt($('#wc_bookings_field_persons_5896').val());
     $('[name="wc_bookings_field_persons_146693"]').val(persons)
   }else{
     $('[name="wc_bookings_field_persons_146693"]').val(0)
   }
 }

$('[for="wc_bookings_field_persons_146700"]' ).prepend( '<input type="checkbox" id="wc_bookings_checkbox_persons_146700" value="true" style=" width: auto; margin-right: 5px;"/>' );
$('[name="wc_bookings_field_persons_146700"]').hide();
$('#wc_bookings_checkbox_persons_146700, #wc_bookings_field_persons_5901, #wc_bookings_field_persons_5902').change(function() {
  catcheckPicnic2()
});
function catcheckPicnic2(){
  if( $('#wc_bookings_checkbox_persons_146700').prop('checked') ) {
    var persons = parseInt($('#wc_bookings_field_persons_5901').val()) + parseInt($('#wc_bookings_field_persons_5902').val());
    $('[name="wc_bookings_field_persons_146700"]').val(persons)
  }else{
    $('[name="wc_bookings_field_persons_146700"]').val(0)
  }
}

 //ENG

 $('[for="wc_bookings_field_persons_146694"]' ).prepend( '<input type="checkbox" id="wc_bookings_checkbox_persons_146694" value="true" style=" width: auto; margin-right: 5px;"/>' );
 $('[name="wc_bookings_field_persons_146694"]').hide();
 $('#wc_bookings_checkbox_persons_146694, #wc_bookings_field_persons_5897, #wc_bookings_field_persons_5898').change(function() {
   engcheckPicnic()
 });
 function engcheckPicnic(){
   if( $('#wc_bookings_checkbox_persons_146694').prop('checked') ) {
     var persons = parseInt($('#wc_bookings_field_persons_5897').val()) + parseInt($('#wc_bookings_field_persons_5898').val());
     $('[name="wc_bookings_field_persons_146694"]').val(persons)
   }else{
     $('[name="wc_bookings_field_persons_146694"]').val(0)
   }
 }

 $('[for="wc_bookings_field_persons_146699"]' ).prepend( '<input type="checkbox" id="wc_bookings_checkbox_persons_146699" value="true" style=" width: auto; margin-right: 5px;"/>' );
$('[name="wc_bookings_field_persons_146699"]').hide();
$('#wc_bookings_checkbox_persons_146699, #wc_bookings_field_persons_5903, #wc_bookings_field_persons_5904').change(function() {
  engcheckPicnic2()
});
function engcheckPicnic2(){
  if( $('#wc_bookings_checkbox_persons_146699').prop('checked') ) {
    var persons = parseInt($('#wc_bookings_field_persons_5903').val()) + parseInt($('#wc_bookings_field_persons_5904').val());
    $('[name="wc_bookings_field_persons_146699"]').val(persons)
  }else{
    $('[name="wc_bookings_field_persons_146699"]').val(0)
  }
}
  //End picnic


});
